import { AlertCircle } from "lucide-react";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Button } from "~/components/ui/button";

interface ShareAccessDeniedProps {
  message?: string;
}

export const ShareAccessDenied: FC<ShareAccessDeniedProps> = ({ message }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 text-center">
      <div className="rounded-full bg-red-100 p-3">
        <AlertCircle className="h-8 w-8 text-red-600" />
      </div>
      <div>
        <h1 className="text-xl font-semibold text-gray-900">
          <FormattedMessage
            id="share.accessDenied.title"
            defaultMessage="Access Denied"
          />
        </h1>
        <p className="mt-2 text-sm text-gray-600">
          {message || (
            <FormattedMessage
              id="share.accessDenied.message"
              defaultMessage="This share link is invalid or has expired."
            />
          )}
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to="/login">
          <FormattedMessage
            id="share.accessDenied.login"
            defaultMessage="Go to Login"
          />
        </Link>
      </Button>
    </div>
  );
};
